module.exports = __webpack_public_path__ + "static/media/card-hosting-es.e51bcb29.png";